export const environment = {
  name: 'dev',
  production: false,
  apiUrl:'https://portal-sititramites.sitiapp.com',
    recaptchaV2SiteKey: '6LfKuLkqAAAAAMUMHvvekHvPI3iKcBUdrWH9F-mm',
    recaptchaV3SiteKey: '6Lf0_LkqAAAAAE1U32eLQ6QevROo5FUid_oUTkIX',
  portalUrl:'https://portal-gobmag.sitiapp.com',
  recaptchaIgnore: false,
};


